import React from "react";
// import PageTitle from "../../../../components/page-title/PageTitle";
import { Row, Col, Container } from "react-bootstrap";
import {
  /*  TeamRole,
    Country,*/
  UserRole,
} from "../../../../../../shared/constants/Constant";
import PageHeader from "../../../../components/page-header/PageHeader";
import RegistrationForm from "./components/registrationForm";

/*interface Data {
  // id: string;
  teamName: string;
  teamDetails: string;
  teamProgres: string;
  teamMembers: TeamMember[];
  country: Country;
}*/

/*interface TeamMember {
  fullName?: string;
  email?: string;
  university?: string;
  state?: string;
  role?: TeamRole;
  contact?: string;
  country?: Country;
  createdAt?: Date;
  updatedAt?: Date;
}*/

interface IProps {
  userRole: UserRole;
}

const CreateAccount = (props: IProps) => {
  return (
    <>
      <PageHeader
        title={
          props.userRole.isAdmin
            ? "Create an administrator account"
            : props.userRole.isModerator ? "Create a moderator account" : "Create a member account"
        }
        showBackButton={true}
      />
      <Container fluid style={{ paddingTop: "0px" }}>
        <Row style={{ height: "175px" }} />
        <Row>
          <Col
            xs={12}
            style={{
              padding: "20px",
              paddingLeft: "40px",
              paddingRight: "40px",
            }}
          >
            <RegistrationForm {...props} />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CreateAccount;
